import { processTransactionReq } from "../../interfaces/projectCategory";
import { postData } from "./api";

// export async function fetchToken() {
//   return postData(
//     `https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/token`,
//     {
//       token: "india-wwf-api-key-9X47QZ",
//     }
//   );
// }

// export async function searchData(data: processTransactionReq) {
//   return postData(
//     `https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/processTransaction`,
//     data
//   );
// }

export async function getsearchData(data: processTransactionReq) {
  return postData(
    `https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/NewProcessTransaction`,
    //`https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/wwf/processTransaction`,
    data
  );
}
